module.exports = __webpack_public_path__ + "55f87dc506f0d33eb58cebdbb4502956.jpg";